import { Route, NavigationGuardNext } from "vue-router";
import { ReportsModule } from "@/modules/reports-objective";

export const ReportsResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	actions.push(ReportsModule.getVCSLevelUnits());
	await Promise.all(actions);
	next();
};
